import { React, useState } from "react";
import classes from './MobileOptimisation.module.scss';

//MUI Imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';



function ScreenSize() {

    const [isActive, setActive] = useState(false);

    const toggleClass = () => {
      setActive(!isActive);
    };
  
    return (
        <Box className={``}>
            <div className={isActive ? classes.MobileOptimisation__disabled : classes.MobileOptimisation__active } >
                <div className={classes.MobileOptimisation__message}>
                    <p>
                        This programme is best used on desktop size devices (992px and above). Some features may not be compatible on mobile and tablet devices or screens of a smaller size.
                    </p>
                    <div className={`inline_button inline_button__large ${classes.MobileOptimisation__button}`}>
                        <Button variant="contained"
                            onClick={() => { toggleClass() }}
                        >
                            Continue
                        </Button>
                    </div>
                </div>
            </div>
        </Box>
    );
}
export default ScreenSize